import { apiFunction } from "../../apiCall/function"

export const getCertInfo = async (data) => {
  return await apiFunction("certificate/verify", "post", data, true, 'body')
}
